import { render, staticRenderFns } from "./UserBlockFraud.vue?vue&type=template&id=6fa86568"
import script from "./UserBlockFraud.vue?vue&type=script&lang=js"
export * from "./UserBlockFraud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports